// extracted by mini-css-extract-plugin
export var originalPrice = "_vz-0";